<template>
  <div class="container-lg mt-12">
    <div class="row">
      <div v-for="banner in featured_banners" class="col-sm-6">
        <div :title="banner.title" class="featured_banner">
          <picture>
            <source :srcset="banner.image.webp" type="image/webp">
            <img :src="banner.image.source"
                 alt="image"
                 data-sizes="auto"
                 class="img mx-auto lazyload"
            >
          </picture>
          <div class="absolute left-[2.1rem] top-1/2 -translate-y-1/2 text-charcoal w-[50%]">
            <div class="text-[18px] lg:text-[28px] font-semibold">
              {{ banner.title }}
            </div>
            <div class="text-[14px] lg:text-[16px] mb-4">
              {{ banner.sub_title }}
            </div>
            <a :href="banner.link" :title="banner.link_title" class=" text-[16px] leading-[24px] font-semibold text-hot-pink">
              {{ banner.link_title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name:  "Featured",
  props: [
    'featured_banners',
  ],
}
</script>

<style scoped>
.featured_banner {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
}

.featured_banner__content {
  position: absolute;
  left: 10%; /* Move content to the left */
  bottom: 50%;
  color: white;
  z-index: 10;
  text-align: left; /* Align text content to the left */
  width: 50%;
}

.featured_banner__title {
  font-size: 2.4rem; /* Increase font size to match desired look */
  font-weight: bold;
  color: #252525;
}

.featured_banner__sub_title {
  font-size: 1.2rem;
  font-weight: 300;
  color: #060606;
}

.featured_banner__button {
  display: inline-block;
  font-weight: 500;
  text-decoration: none;
  font-size: 1.2rem;
  color: #c90163;
}
</style>